export enum AppRoute {
  home = '/',
  accountType = '/accountType',
  dashboard = '/dashboard',
  issueAsset = '/issueAsset',
  issueInstallation = '/issueInstallation',
  issueVerification = '/issueVerification',
  activateAsset = '/activateAsset',
  details = '/details/:id',
  settings = '/settings',
  settingsGeneral = '/settings/general',
  desktopDashboardGrid = '/batteries',
  batteriesDetails = '/batteries/:id',
  approveAssetOwner = '/approveAssetOwner',
  desktopMintTokens = '/mintTokens',
}
